module.exports = __webpack_public_path__ + "img/Evaluation Process_Tier 1_Page_2.d180df15.jpg";